module.exports = __webpack_public_path__ + "img/checked-option-white.eb64bc3e.svg";